<template>
    <div class="headingbasicdetailsrules">
        <p class="notification is-info"> Tell us the basic details of your travel policy.</p>
          <div class="columncstm">
            <b-field label="Travel Policy Name">
            <b-input type="text"  required validation-message="Please enter a name for this travel policy" v-model="basicDetailsObj.ruleClass" @input="getBasicDetails" />
            </b-field>
          </div>
         <h1 >Payment Methods</h1>
          <div class="columncstm">
            <b-field label="Default payment method">
                <!-- <b-select v-model="basicDetailsObj.corporateGhostCard" @input="getBasicDetails" >
                  <option value="Corporate Ghost Card">Corporate Ghost Card</option>
                  
                </b-select> -->
                <b-select
                        
                        placeholder="Select Corporate Ghost Card"  v-model="basicDetailsObj.corporateGhostCard" @input="getBasicDetails"
                        expanded
                      >
                        <option value="">--None--</option>
                        <option
                          v-for="option in cardOptions"
                          :value="option"
                          :key="option.id"
                        >
                          {{ option.brand }} Card ending in {{option.last4}}
                        </option>
                      </b-select>
            </b-field>
          </div>
         <b-field label="Allow personal payment methods?">
            <b-checkbox type="is-teal" @input="getBasicDetails"  v-model="basicDetailsObj.allowPersonalPaymentMethods" >
              <p>Yes</p>
          </b-checkbox>
         </b-field>
         <h1>Communication</h1>
         <b-field label="Email address to notify of all bookings">
         <div class="columncstm">
          <b-input type="email" v-model="basicDetailsObj.ccEmail" @input="getBasicDetails"/>
        </div>
        </b-field>
         <h1 >Flight Search options</h1>
         <b-field label="Do you want to allow basic economy fares?"></b-field>
         <b-checkbox type="is-teal"  true-value="Yes"
                false-value="No" v-model="basicDetailsObj.allowBasicEconomyFares"   @input="getBasicDetails">
            <p>Yes</p></b-checkbox>
        <b-field  label="Which cabin classes should be available in the flight search form?"></b-field>
        <b-checkbox type="is-teal" @input="getBasicDetails"  native-value="Y" v-model="basicDetailsObj.cabinOptions" ><p>Economy</p></b-checkbox><br />
        <b-checkbox  type="is-teal"  @input="getBasicDetails" native-value="M"  v-model="basicDetailsObj.cabinOptions" > <p>Standard Economy</p></b-checkbox><br />
        <b-checkbox  type="is-teal" @input="getBasicDetails" native-value="W" v-model="basicDetailsObj.cabinOptions" ><p>Premium Economy</p></b-checkbox><br />
        <b-checkbox  type="is-teal" @input="getBasicDetails" native-value="C" v-model="basicDetailsObj.cabinOptions" ><p>Business</p></b-checkbox><br />
        <b-checkbox  type="is-teal" @input="getBasicDetails" native-value="F" v-model="basicDetailsObj.cabinOptions" ><p>First</p></b-checkbox>
    </div>
</template>
<script>

export default {
    name:"BasicDetails",
    components :{
    },
    props: {
    travelPolicy: {
      type: [Object],
    },
    cardOptions:{
      type:Array
    }
  },
    data() {
        return {
          basicDetailsObj :{
                  ruleClass : '',
                  corporateGhostCard :'',
                  allowPersonalPaymentMethods : false,
                  ccEmail : '',
                  allowBasicEconomyFares :'No',
                  cabinOptions: []
          }
        }
      },
      methods:{
            getBasicDetails(){
            this.$emit('basicDetails',this.basicDetailsObj);
            },
      },
      mounted() {
        this.$emit('basicDetails',this.basicDetailsObj);
      },
      watch: {
    
    travelPolicy: {
      handler(newVal, prevVal) {

        this.basicDetailsObj.ruleClass=newVal.ruleClass;
        this.basicDetailsObj.corporateGhostCard=newVal.corporateGhostCard;
        this.basicDetailsObj.allowPersonalPaymentMethods=newVal.allowPersonalPaymentMethods;
        this.basicDetailsObj.ccEmail=newVal.ccEmail;
        this.basicDetailsObj.allowBasicEconomyFares=newVal.allowBasicEconomyFares;
        this.basicDetailsObj.cabinOptions=newVal.cabinOptions;
        this.$emit('basicDetails',this.basicDetailsObj);

     
      },
      deep: true,
    }
      
}
      
}
</script>
